const LISTING_PAGE_EXPERIMENTS_LAYER = 'listing_page_experiments';

// Statsig's Events

export const STATSIG_EVENT_NAMES = {
    LISTING_APP_PAGE_VIEW: 'Listing - App - View - Page',
    LISTING_CONVERSION_BAR_CTA_CLICK: 'Listing - conversionBar - Click - CTA',
    LISTING_TICKET_SELECTION_VIEW:
        'Listing - Conversion Bar - Ticket Selection - View',
    LISTING_ALL_EVENT_DETAILS_VIEW:
        'Listing - All - Click - View All Event Details',
    LISTING_TICKET_SELECTION_CLICK:
        'Listing - Conversion Bar - Ticket Selection - Click',
    CHILD_EVENTS_DROPDOWN:
        'Listing - Select a date - Change - Child Events Dropdown',
    MORE_OPTIONS_BUTTON:
        'Listing - Select a date - Click - More Options Button',
    MORE_OPTIONS_CARD: 'Listing - Select a date - Click - More Options Card',
    CAROUSEL_CARD: 'Listing - Select a date - Click - Carousel card',
    LISTING_MORE_ORGANIZER_EVENT_CLICK:
        'Listing - All - Click - More Organizer Event',
    LISTING_MORE_ORGANIZER_EVENT_LIKE:
        'Listing - All - Click - More Organizer Event Like',
    LISTING_MORE_ORGANIZER_EVENT_SHARE:
        'Listing - All - Click - More Organizer Event Share',
    LISTING_RELATED_EVENT_CLICK: 'Listing - All - Click - Related Event',
    LISTING_RELATED_EVENT_LIKE: 'Listing - All - Click - Related Event Like',
    LISTING_RELATED_EVENT_SHARE: 'Listing - All - Click - Related Event Share',
};

// Heap ID's

export const LISTING_HEAP_IDS = {
    CAROUSEL_CARD: 'Hero Content - Carousel card - Change',
    CHILD_EVENTS_DROPDOWN: 'Listing - Date - Child Events Dropdown - Click',
    CHECKOUT_BUTTON: 'Conversion Bar - Checkout Button',
    CREATOR_TOP_BANNER_EDIT: 'Creator Top Banner - Edit',
    CTA_RSVP_MAYBE: 'Listing - Conversion Bar - RSVP Maybe - Click',
    CTA_RSVP_NO: 'Listing - Conversion Bar - RSVP No - Click',
    DESCRIPTIVE_ORGANIZER:
        'Listing - Descriptive Organizer Panel - Follow - Click',
    EXPLORE_SIMILAR_EVENTS:
        'Listing - Conversion Bar - Explore Similar Events - Click',
    FAQS_DROPDOWN: 'FAQs - Dropdown',
    FOLLOW_BUTTON: 'Listing - Follow - Button - Click',
    HERO_VIDEO: 'Promo Video - Play',
    HIDE_MAP: 'Listing - Hide Map - Button - Click',
    IMAGE_CATEGORY_CLICK:
        'Listing - Expired Event Page - Click - Category Browse',
    IMAGE_CATEGORY_VIEW:
        'Listing - Expired Event Page - View - Category Browse',
    LEFT_ARROW_HERO_CAROUSEL: 'Hero Content - Hero Carousel - Left',
    MAP_DRIVE: 'Listing - Map - Drive - Click',
    MAP_WALK: 'Listing - Map - Walk - Click',
    MAP_BUS: 'Listing - Map - Bus - Click',
    MAP_BIKE: 'Listing - Map - Bike - Click',
    MAP_ZOOM_CHANGE: 'Listing - Map - Zoom - Change',
    MORE_COLLECTIONS_THAT_FEATURE_EVENT:
        'More Collections That Feature This Event - View more collections Button',
    MORE_OPTIONS_BUTTON:
        'Hero Content - More options button in Repeating events - Click',
    MORE_OPTIONS_CARD:
        'Hero Content - More options last card in Repeating events - Click',
    MORE_OPTIONS_DATE:
        'Hero Content - Change date confirmation in Calendar - Click',
    ONLINE_EVENT_ACCESS_BUTTON:
        'Listing - Online Location - Access the Event - Click',
    ORGANIZER_FACEBOOK:
        'Listing - Organizer Panel - Organizer Facebook - Click',
    ORGANIZER_NAME: 'Listing - Organizer Panel - Organizer Name - Click',
    ORGANIZER_TWITTER: 'Listing - Organizer Panel - Organizer Twitter - Click',
    ORGANIZER_WEBSITE: 'Listing - Organizer Panel - Organizer Website - Click',
    PART_OF_A_COLLECTION:
        'Hero Content - Part of /Featured in Collection/s button',
    RIGHT_ARROW_HERO_CAROUSEL: 'Hero Content - Hero Carousel - Right',
    SHARE_EVENT: 'Listing - Hero - Share - Click',
    SHOW_MAP: 'Listing - Show Map - Button - Click',
    SIMPLIFIED_ORGANIZER:
        'Listing - Simplified Organizer Panel - Follow - Click',
    UNFOLLOW_BUTTON: 'Listing - Following - Button - Click',
};

export const SALES_STATUS_ON_SALE = 'on_sale';

// Statsig's Multi Tickets Experiment
export const MULTI_TICKETS_ON_LISTINGS_PAGE_EXPERIMENT = {
    defaultValue: false,
    layer: LISTING_PAGE_EXPERIMENTS_LAYER,
    param: 'multi_ticket_selection',
};

// Statsig's Unifying Repeating Events Customer Experience Experiment
export const LISTING_PAGE_UNIFYING_REPEATING_EVENTS_CONSUMER_EXPERIMENT = {
    experiment: 'listing_unify_repeating_events_consumer_experience',
    defaultValue: false,
    param: 'parent_shows_child_info',
};
// Statsig's Sales Ended Listing Experiment for Personalization Team
export const SALES_ENDED_LISTINGS_PAGE_EXPERIMENT = {
    experimentName: 'sales_ended_listings',
    param: 'enhanced_listing',
    defaultValue: false,
};

// Statsig's Early Bird shown as discount
export const LISTING_EARLY_BIRD_PLACEMENT_IMPACT = {
    experimentName: 'listing_early_bird_placement_impact',
    param: 'show_early_bird_as_discount',
    defaultValue: false,
};
